// Confronto tollerante tra nomi: NFC, senza spazi ai bordi, senza distinzione di maiuscole
const normalizeName = (name) => (typeof name === 'string' ? name.normalize('NFC').trim().toLowerCase() : '');

// Trova la categoria di un nome: prima uguaglianza esatta, poi confronto normalizzato
export function findCategoryByName(categories, name) {
  if (!Array.isArray(categories) || !normalizeName(name)) return undefined;
  const key = normalizeName(name);
  return categories.find(cat => cat.name === name) || categories.find(cat => normalizeName(cat.name) === key);
}

// Nomi usati ma assenti dalla lista (ripuliti, senza doppioni)
export function findMissingCategories(categories, names) {
  const missing = new Map();
  (names || []).forEach(name => {
    const key = normalizeName(name);
    if (key && !findCategoryByName(categories, name) && !missing.has(key)) missing.set(key, name.trim());
  });
  return [...missing.values()];
}

// Copia i movimenti mettendo in `field` il nome canonico della lista; non tocca gli originali
export function withCanonicalCategory(items, categories, field = 'category') {
  if (!Array.isArray(items)) return items;
  return items.map(item => {
    const canonical = findCategoryByName(categories, item?.[field])?.name;
    return canonical && canonical !== item[field] ? { ...item, [field]: canonical } : item;
  });
}

// Aggiunge una nuova categoria, restituisce il nuovo array
export function addCategory(categories, newCategory) {
  if (!newCategory || !newCategory.name || !newCategory.icon) throw new Error('Categoria non valida');
  const name = newCategory.name.trim();
  if (!name) throw new Error('Categoria non valida');
  if (findCategoryByName(categories, name)) throw new Error('Categoria già esistente');

  // Genera un ID univoco usando timestamp + random per evitare conflitti
  const uniqueId = Date.now() + Math.random().toString(36).substr(2, 9);

  return [...categories, { ...newCategory, name, id: uniqueId }];
}

// Modifica una categoria esistente per id
export function editCategory(categories, id, updatedFields) {
  const fields = typeof updatedFields?.name === 'string' ? { ...updatedFields, name: updatedFields.name.trim() } : updatedFields;
  return categories.map(cat =>
    cat.id === id ? { ...cat, ...fields } : cat
  );
}

// Elimina una categoria per id
export function deleteCategory(categories, id) {
  return categories.filter(cat => cat.id !== id);
}

// Valida una categoria (nome non vuoto, icona presente)
export function validateCategory(category) {
  return !!category && !!category.name && !!category.icon;
}
